import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getCompleteSizes } from '@cian/adfox-component';
import { Base64 } from 'js-base64';
import { ParallaxGeneralTemplate } from '../templates/ParallaxGeneralTemplate';
import { PictureTemplate } from '../templates/PictureTemplate';
import { PixelTemplate } from '../templates/PixelTemplate';
import { TgbStretchTemplate } from '../templates/TgbStretchTemplate';
import { useHTMLBannerInserts } from '../utils/useHTMLBannerInserts';
import { jsx as _jsx } from "react/jsx-runtime";
const KNOWN_BUNDLE_NAMES = ['banner.transfer'];
const KNOWN_TYPES = ['tgb_stretch', 'picture', 'pixel', 'parallax_general'];
export const AdFoxTemplates = props => {
  const {
    containerId,
    bundleName,
    bundleParams,
    eventEmitter,
    deviceType,
    height,
    width
  } = props;
  useHTMLBannerInserts({
    containerId,
    eventEmitter
  });
  if (bundleName && KNOWN_BUNDLE_NAMES.includes(bundleName) && bundleParams) {
    if (bundleName === 'banner.transfer' && bundleParams.htmlBase64) {
      try {
        const decodedParams = Base64.decode(bundleParams.htmlBase64);
        const parsedDecodedParams = JSON.parse(decodedParams);
        if (isParsedParamsValid(parsedDecodedParams)) {
          if (KNOWN_TYPES.includes(parsedDecodedParams.type)) {
            switch (parsedDecodedParams.type) {
              case 'parallax_general':
                return /*#__PURE__*/_jsx(ParallaxGeneralTemplate, {
                  context: parsedDecodedParams,
                  deviceType: deviceType,
                  height: height,
                  width: width
                });
              case 'tgb_stretch':
                return /*#__PURE__*/_jsx(TgbStretchTemplate, _objectSpread({}, parsedDecodedParams));
              case 'picture':
                return /*#__PURE__*/_jsx(PictureTemplate, _objectSpread({}, parsedDecodedParams));
              case 'pixel':
                return /*#__PURE__*/_jsx(PixelTemplate, {});
              default:
                // @ts-ignore
                console.warn('[AdFox] Known type is not found', parsedDecodedParams.type, bundleParams);
            }
          } else {
            console.warn('[AdFox] Unknown banner type', parsedDecodedParams.type, bundleParams);
          }
        } else {
          console.error('[AdFox] Invalid parsed params', bundleParams);
        }
      } catch (e) {
        console.error('[AdFox] Failed to decode/parse bundleParams', bundleParams, e);
      }
    } else {
      console.warn('[AdFox] Known bundle is invalid/not found', bundleName, bundleParams);
    }
  } else {
    console.warn('[AdFox] Unknown bundle', bundleName, bundleParams);
  }
  return /*#__PURE__*/_jsx("div", {
    id: containerId,
    style: getCompleteSizes({
      height,
      width
    })
  });
};
function isParsedParamsValid(params) {
  return 'type' in params;
}